import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const BarsIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 2C10 0.89543 10.8954 0 12 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H12C10.8954 18 10 17.1046 10 16V2ZM12 1.2H16C16.4418 1.2 16.8 1.55817 16.8 2V16C16.8 16.4418 16.4418 16.8 16 16.8H12C11.5582 16.8 11.2 16.4418 11.2 16V2C11.2 1.55817 11.5582 1.2 12 1.2Z"
				fill="#393946"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 8C0 6.89543 0.895431 6 2 6H6C7.10457 6 8 6.89543 8 8V16C8 17.1046 7.10457 18 6 18H2C0.895431 18 0 17.1046 0 16V8ZM2 7.2H6C6.44183 7.2 6.8 7.55817 6.8 8V16C6.8 16.4418 6.44183 16.8 6 16.8H2C1.55817 16.8 1.2 16.4418 1.2 16V8C1.2 7.55817 1.55817 7.2 2 7.2Z"
				fill="#393946"
			/>
		</svg>
	</BaseIcon>
);

BarsIcon.propTypes = iconPropTypes;
BarsIcon.defaultProps = iconDefaultProps;
